'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var PropTypes = _interopDefault(require('prop-types'));

var Waypoint = _interopDefault(require('react-waypoint'));

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var defaultStyle = {
  position: 'relative'
};

var VirtualContainer = function (_Component) {
  inherits(VirtualContainer, _Component);

  function VirtualContainer(props) {
    classCallCheck(this, VirtualContainer);

    var _this = possibleConstructorReturn(this, (VirtualContainer.__proto__ || Object.getPrototypeOf(VirtualContainer)).call(this, props));

    _this.handleWaypointChange = function (type) {
      return function (_ref) {
        var currentPosition = _ref.currentPosition,
            previousPosition = _ref.previousPosition;

        if (_this.unmounted) {
          return;
        }

        var waypointIn = type === 'bottom' ? Waypoint.below : Waypoint.above;
        var waypointOut = type === 'bottom' ? Waypoint.above : Waypoint.below;
        var startsNotVisible = previousPosition == null && currentPosition === waypointOut;
        var startsVisible = previousPosition == null && (currentPosition === waypointIn || currentPosition === Waypoint.inside);
        var isNowVisible = previousPosition === waypointOut && (currentPosition === waypointIn || currentPosition === Waypoint.inside);
        var isNowNotVisible = previousPosition === Waypoint.inside && currentPosition === waypointOut;
        var virtualized = startsNotVisible || isNowNotVisible ? true : startsVisible || isNowVisible ? false : _this.state.virtualized;

        if (_this.initialized === false) {
          _this[type] = virtualized;

          if (typeof _this.top !== 'undefined' && typeof _this.bottom !== 'undefined') {
            _this.initialized = true;

            _this.updateVirtualization(_this.top || _this.bottom);
          }
        } else {
          _this.updateVirtualization(virtualized);
        }
      };
    };

    _this.updateVirtualization = function (virtualized) {
      if (_this.state.virtualized !== virtualized) {
        _this.setState({
          virtualized: virtualized
        });

        if (_this.props.onChange) {
          _this.props.onChange(virtualized);
        }
      }
    };

    _this.onBottomWaypointChange = _this.handleWaypointChange('bottom');
    _this.onTopWaypointChange = _this.handleWaypointChange('top');

    _this.refCb = function (el) {
      if (el == null) {
        return;
      }

      _this.el = el;
    };

    _this.state = {
      virtualized: !props.optimistic
    };
    _this.initialized = false;
    return _this;
  }

  createClass(VirtualContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (process.env.NODE_ENV === 'development') {
        if (this.el && getComputedStyle(this.el).position == null) {
          // eslint-disable-next-line no-console
          console.warn('You must provide a "position" style to your VirtualContainer element');
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          el = _props.el,
          inAndOut = _props.inAndOut,
          optimistic = _props.optimistic,
          offsetTop = _props.offsetTop,
          offsetBottom = _props.offsetBottom,
          Placeholder = _props.placeholder,
          scrollableAncestor = _props.scrollableAncestor,
          style = _props.style,
          render = _props.render,
          passThroughProps = objectWithoutProperties(_props, ['children', 'className', 'el', 'inAndOut', 'optimistic', 'offsetTop', 'offsetBottom', 'placeholder', 'scrollableAncestor', 'style', 'render']);
      var virtualized = this.state.virtualized;
      var resolvedRender = children || render;

      if (!resolvedRender) {
        throw new Error('Must provide a children or render function');
      }

      var stopTracking = this.initialized && !inAndOut;
      return React.createElement(el, _extends({}, passThroughProps, {
        className: className,
        style: style != null ? style : className ? undefined : defaultStyle,
        ref: this.refCb
      }), React__default.createElement(React.Fragment, null, !virtualized || stopTracking ? resolvedRender() : Placeholder ? React__default.createElement(Placeholder, null) : null, stopTracking ? null : React__default.createElement(Waypoint, {
        onPositionChange: this.onTopWaypointChange,
        scrollableAncestor: scrollableAncestor
      }, React__default.createElement(WaypointTarget, {
        top: true,
        offsetTop: offsetTop
      })), stopTracking ? null : React__default.createElement(Waypoint, {
        onPositionChange: this.onBottomWaypointChange,
        scrollableAncestor: scrollableAncestor
      }, React__default.createElement(WaypointTarget, {
        offsetBottom: offsetBottom
      }))));
    }
  }]);
  return VirtualContainer;
}(React.Component);

VirtualContainer.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
  el: PropTypes.string,
  inAndOut: PropTypes.bool,
  onChange: PropTypes.func,
  offsetBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offsetTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  optimistic: PropTypes.bool,
  placeholder: PropTypes.func,
  render: PropTypes.func,
  scrollableAncestor: PropTypes.any,
  style: PropTypes.object
};
VirtualContainer.defaultProps = {
  children: undefined,
  className: undefined,
  el: 'div',
  inAndOut: false,
  offsetBottom: '50vh',
  offsetTop: '50vh',
  optimistic: false,
  onChange: undefined,
  placeholder: undefined,
  render: undefined,
  scrollableAncestor: undefined,
  style: undefined
};

var WaypointTarget = function WaypointTarget(_ref2) {
  var _ref3;

  var innerRef = _ref2.innerRef,
      offsetBottom = _ref2.offsetBottom,
      offsetTop = _ref2.offsetTop,
      top = _ref2.top;
  return React__default.createElement('div', {
    style: (_ref3 = {
      backgroundColor: 'red'
    }, defineProperty(_ref3, top ? 'top' : 'bottom', 0), defineProperty(_ref3, 'height', '1px'), defineProperty(_ref3, 'left', 0), defineProperty(_ref3, 'position', 'absolute'), defineProperty(_ref3, 'transform', 'translateY(' + (top ? '-' + offsetTop : offsetBottom) + ')'), defineProperty(_ref3, 'width', '1px'), _ref3),
    ref: innerRef
  }, '\xA0');
};

WaypointTarget.propTypes = {
  innerRef: PropTypes.any,
  offsetBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  offsetTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  top: PropTypes.bool
};
WaypointTarget.defaultProps = {
  innerRef: undefined,
  offsetBottom: 0,
  offsetTop: 0,
  top: false
};
module.exports = VirtualContainer;